$(document).ready(() => {
  var iconSearchSlt = "[data-search-mobile-toggle]",
      wrapperHeader = $(".wrapper-header"),
      formSearch = wrapperHeader.find(".search-form:visible");

    $("[data-search-mobile-toggle]")
      .on(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("html").addClass("search-open");
        $(".scs-currency-block .dropdown-menu.currency-menu").hide();
        $("#dropdown-cart").hide();
        $("[data-popup-video]").hide();
    
        var self = $(this);
        var url = self.data("url");
        var limit = self.data("limit");
        var grid = self.data("limit");
        $.ajax({
          type: "get",
          url: window.router + "/collections/" + url,
          cache: false,
          data: {
            view: "list_product",
            constraint:
              "limit=" +
              limit +
              "+grid=" +
              grid +
              "+sectionId=search-form-product",
          },
          beforeSend: function () {
            self.addClass("ajax-loaded");
          },
          success: function (data) {
            if (url != "") {
                $(".search-bar:visible .search__products").find(".products-grid").html(data);
             
            }
            $('[data-toggle="tooltip"]').tooltip({container: 'body'});  
            swapHoverVideo();
          },
          complete: function () {
           
          },
        });
      });

      $(document).on("click", function (e) {
            var searchForm = $(".wrapper-header .search-form:visible .search-bar");
        var searchProduct = $(".wrapper-header .header-search__product");
        var searchTrending = $(".wrapper-header .header-search__trending");
        var overlay = $(".wrapper-overlay");
        var iconSearchSlt = $("[data-search-mobile-toggle]");
        var slideshow = $(".home-slideshow .slide-action");

        if (
          !searchForm.is(e.target) &&
          !iconSearchSlt.is(e.target) &&
          !slideshow.has(e.target).length &&
          !searchForm.has(e.target).length &&
          !searchProduct.has(e.target).length &&
          !searchTrending.has(e.target).length &&
          !overlay.has(e.target).length
        ) {
          $("html").removeClass("search-open");
          $(".quickSearchResultsWrap").hide();
          $(".close-search-style-3").hide();
          $(".search-form .search-overlay").hide();
        }
      });
});